<template>
    <ValidationObserver :ref="stepName" v-slot="observer">

        <div class="field-container">
            <component :is="fields.street._component" :key="'street'" :name="'street'" :field="fields.street" :step="step"></component>
        </div>

        <div class="multi-field-row">
            <div class="field-container">
                <component :is="fields.street_number._component" :key="'street_number'" :name="'street_number'" :field="fields.street_number" :step="step"></component>
            </div>
            <div class="field-container">
                <component :is="fields.street_box_number._component" :key="'street_box_number'" :name="'street_box_number'" :field="fields.street_box_number" :step="step"></component>
            </div>
        </div>

        <div class="field-container">
            <component :is="fields.zip_code._component" :key="'zip_code'" :name="'zip_code'" :field="fields.zip_code" :step="step"></component>
        </div>

        <div class="field-container">
            <component :is="fields.city._component" :key="'city'" :name="'city'" :field="fields.city" :step="step" style="width: 100%"></component>
        </div>

        <!--<b-button type="button next-button is-primary" :disabled="block_form||showInvalid" v-html="step._button" @click="nextStep()"></b-button>-->
        <b-button type="button next-button is-primary" v-html="step._button" @click="nextStep()"></b-button>
    </ValidationObserver>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import form_step_mixin from '../../../form_step_mixin'
import {Text} from "../../../../../../models/fields/Text";
import {Select} from "../../../../../../models/fields/Select";
import {Option} from "../../../../../../models/fields/Features/Option";
import {MaskPattern} from "../../../../../../models/fields/Features/mask/MaskPattern";

import {sync} from 'vuex-pathify';

export default {
    mixins: [mixin, form_step_mixin],
    computed: {
        zip_code: sync('form_data/zip_code'),
        city: sync('form_data/city'),
    },
    data() {
        return {
            requestStatus: true,
            fields: {
                city: new Text().label('Localité').required().validation({max: 80}),
                street: new Text().label('Rue').required().validation({max: 80}),
                street_number: new Text().label('N°').required().validation({max: 80}),
                street_box_number: new Text().label('Boîte').validation({max: 80}),
                zip_code: new Text().type('number').label('Code postal')
                    .required()
                    .validation({
                        regex: /^\d{4}$/
                    }).mask(new MaskPattern('0000').showPlaceholder('X')),
            }
        }
    },
}
</script>
